import React from 'react';
import { connect } from 'react-redux';
import ProductEntry from './ProductEntryPage.component';
import { getLinkType } from '../../reducers/feature.reducer';
import Helpers from '../../helpers/Helpers';

export const mapStateToProps = (state, ownProps) => {
  const { feature } = state;
  const { pathname, search } = ownProps.location;
  const { params: { itemId } } = ownProps.match;

  const linkTypeParams = {
    state: feature,
    page: 'pep'
  };

  const { nValue = '' } = Helpers.getQueryParams(search);
  const linkType = getLinkType({ ...linkTypeParams, tag: 'product_pod' });
  const seeFullDetailsLinkType = getLinkType({ ...linkTypeParams, tag: 'see_full_details' });

  return {
    nValue,
    itemId,
    linkType,
    pathname,
    querystring: search,
    seeFullDetailsLinkType,
  };
};

export const mapDispatchToProps = (_, ownProps) => {
  const { push, replace } = ownProps.history;
  return {
    push,
    replace
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductEntry);
